"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.bsc = exports.polygon = void 0;
exports.polygon = {
    mainnet: {
        brc20Router: "",
    },
    testnet: {
        brc20Router: "0x30307023228Af20411D37f487f80b912fAdB07BA",
    },
};
exports.bsc = {
    mainnet: {
        brc20Router: "0xAB82c4Ae964bfBf257297AC55Bb9Fae0AD0084C7",
    },
    testnet: {
        brc20Router: "",
    },
};
//# sourceMappingURL=contracts-address.js.map